export default __webpack_public_path__ + "static/media/01_grandmother.c653acd0.png";